import {
  getCurrentCountryCode,
} from "@/utils/countryConfigUtils";

import BfLogo from "@/assets/country/bf/logo.webp";
import BjLogo from "@/assets/country/bj/logo.webp";
import CiLogo from "@/assets/country/ci/logo.webp";
import EgLogo from "@/assets/country/eg/logo.webp";
import GhLogo from "@/assets/country/gh/logo.webp";
import KeLogo from "@/assets/country/ke/logo.png";
import MxLogo from "@/assets/country/mx/logo.webp";
import NgLogo from "@/assets/country/ng/logo.webp";
import SnLogo from "@/assets/country/sn/logo.webp";
import TgLogo from "@/assets/country/tg/logo.webp";
import TzLogo from "@/assets/country/tz/logo.webp";
import ZmLogo from "@/assets/country/zm/logo.webp";

import BfBanner50 from "@/assets/country/bf/firstUp/banner50.webp";
import BjBanner50 from "@/assets/country/bj/firstUp/banner50.webp";
import CiBanner50 from "@/assets/country/ci/firstUp/banner50.webp";
import EgBanner50 from "@/assets/country/eg/firstUp/banner50.webp";
import GhBanner50 from "@/assets/country/gh/firstUp/banner50.webp";
import KeBanner50 from "@/assets/country/ke/firstUp/banner50.webp";
import MxBanner50 from "@/assets/country/mx/firstUp/banner50.webp";
import NgBanner50 from "@/assets/country/ng/firstUp/banner50.webp";
import SnBanner50 from "@/assets/country/sn/firstUp/banner50.webp";
import TgBanner50 from "@/assets/country/tg/firstUp/banner50.webp";
import TzBanner50 from "@/assets/country/tz/firstUp/banner50.webp";
import ZmBanner50 from "@/assets/country/zm/firstUp/banner50.webp";

import BfLoginCover from "@/assets/country/bf/login/cover.webp";
import BjLoginCover from "@/assets/country/bj/login/cover.webp";
import CiLoginCover from "@/assets/country/ci/login/cover.webp";
import EgLoginCover from "@/assets/country/eg/login/cover.webp";
import GhLoginCover from "@/assets/country/gh/login/cover.webp";
import KeLoginCover from "@/assets/country/ke/login/cover.webp";
import MxLoginCover from "@/assets/country/mx/login/cover.webp";
import NgLoginCover from "@/assets/country/ng/login/cover.webp";
import SnLoginCover from "@/assets/country/sn/login/cover.webp";
import TgLoginCover from "@/assets/country/tg/login/cover.webp";
import TzLoginCover from "@/assets/country/tz/login/cover.webp";
import ZmLoginCover from "@/assets/country/zm/login/cover.webp";

// Country-specific popup images
import BfLoginPopup from "@/assets/country/bf/login/login_popup.webp";
import BfInvitePopup from "@/assets/country/bf/invite/invite_popup.webp";
import BjLoginPopup from "@/assets/country/bj/login/login_popup.webp";
import BjInvitePopup from "@/assets/country/bj/invite/invite_popup.webp";
import EgLoginPopup from "@/assets/country/eg/login/login_popup.webp";
import EgInvitePopup from "@/assets/country/eg/invite/invite_popup.webp";
import GhLoginPopup from "@/assets/country/gh/login/login_popup.webp";
import GhInvitePopup from "@/assets/country/gh/invite/invite_popup.webp";
import KeLoginPopup from "@/assets/country/ke/login/login_popup.webp";
import KeInvitePopup from "@/assets/country/ke/invite/invite_popup.webp";
import CiLoginPopup from "@/assets/country/ci/login/login_popup.webp";
import CiInvitePopup from "@/assets/country/ci/invite/invite_popup.webp";
import NgLoginPopup from "@/assets/country/ng/login/login_popup.webp";
import NgInvitePopup from "@/assets/country/ng/invite/invite_popup.webp";
import SnLoginPopup from "@/assets/country/sn/login/login_popup.webp";
import SnInvitePopup from "@/assets/country/sn/invite/invite_popup.webp";
import TgLoginPopup from "@/assets/country/tg/login/login_popup.webp";
import TgInvitePopup from "@/assets/country/tg/invite/invite_popup.webp";
import ZmLoginPopup from "@/assets/country/zm/login/login_popup.webp";
import ZmInvitePopup from "@/assets/country/zm/invite/invite_popup.webp";
import MxLoginPopup from "@/assets/country/mx/login/login_popup.webp";
import MxInvitePopup from "@/assets/country/mx/invite/invite_popup.webp";
import TzLoginPopup from "@/assets/country/tz/login/login_popup.webp";
import TzInvitePopup from "@/assets/country/tz/invite/invite_popup.webp";

// Country-specific install prompt images (facebook / default browser)
import BfInstallFacebook from "@/assets/country/bf/install/install_facebook.webp";
import BfInstallDefault from "@/assets/country/bf/install/install_default.webp";
import BjInstallFacebook from "@/assets/country/bj/install/install_facebook.webp";
import BjInstallDefault from "@/assets/country/bj/install/install_default.webp";
import EgInstallFacebook from "@/assets/country/eg/install/install_facebook.webp";
import EgInstallDefault from "@/assets/country/eg/install/install_default.webp";
import GhInstallFacebook from "@/assets/country/gh/install/install_facebook.webp";
import GhInstallDefault from "@/assets/country/gh/install/install_default.webp";
import NgInstallFacebook from "@/assets/country/ng/install/install_facebook.webp";
import NgInstallDefault from "@/assets/country/ng/install/install_default.webp";
import ZmInstallFacebook from "@/assets/country/zm/install/install_facebook.webp";
import ZmInstallDefault from "@/assets/country/zm/install/install_default.webp";
import KeInstallFacebook from "@/assets/country/ke/install/install_facebook.webp";
import KeInstallDefault from "@/assets/country/ke/install/install_default.webp";
import CiInstallFacebook from "@/assets/country/ci/install/install_facebook.webp";
import CiInstallDefault from "@/assets/country/ci/install/install_default.webp";
import SnInstallFacebook from "@/assets/country/sn/install/install_facebook.webp";
import SnInstallDefault from "@/assets/country/sn/install/install_default.webp";
import TgInstallFacebook from "@/assets/country/tg/install/install_facebook.webp";
import TgInstallDefault from "@/assets/country/tg/install/install_default.webp";
import MxInstallFacebook from "@/assets/country/mx/install/install_facebook.webp";
import MxInstallDefault from "@/assets/country/mx/install/install_default.webp";
import TzInstallFacebook from "@/assets/country/tz/install/install_facebook.webp";
import TzInstallDefault from "@/assets/country/tz/install/install_default.webp";

// Country-specific withdrawal Official App prompt heroes
import BfWithdrawOfficialAppHero from "@/assets/country/bf/install/withdraw_official_app.webp";
import BjWithdrawOfficialAppHero from "@/assets/country/bj/install/withdraw_official_app.webp";
import CiWithdrawOfficialAppHero from "@/assets/country/ci/install/withdraw_official_app.webp";
import EgWithdrawOfficialAppHero from "@/assets/country/eg/install/withdraw_official_app.webp";
import GhWithdrawOfficialAppHero from "@/assets/country/gh/install/withdraw_official_app.webp";
import KeWithdrawOfficialAppHero from "@/assets/country/ke/install/withdraw_official_app.webp";
import MxWithdrawOfficialAppHero from "@/assets/country/mx/install/withdraw_official_app.webp";
import NgWithdrawOfficialAppHero from "@/assets/country/ng/install/withdraw_official_app.webp";
import SnWithdrawOfficialAppHero from "@/assets/country/sn/install/withdraw_official_app.webp";
import TgWithdrawOfficialAppHero from "@/assets/country/tg/install/withdraw_official_app.webp";
import TzWithdrawOfficialAppHero from "@/assets/country/tz/install/withdraw_official_app.webp";
import ZmWithdrawOfficialAppHero from "@/assets/country/zm/install/withdraw_official_app.webp";

import NgLicense1 from "@/assets/country/ng/bottomInfo/license-1.webp";
import NgLicense2 from "@/assets/country/ng/bottomInfo/license-2.webp";

export type CountryAssetKey =
  | "logo"
  | "firstUpBanner50"
  | "loginPosterCover"
  | "bottomInfoLicense1"
  | "bottomInfoLicense2"
  | "loginPopup"
  | "invitePopup"
  | "installBannerFacebook"
  | "installBannerDefault"
  | "withdrawOfficialAppHero";

type OptionalCountryAssetKey = "bottomInfoLicense1" | "bottomInfoLicense2";
type RequiredCountryAssetKey = Exclude<CountryAssetKey, OptionalCountryAssetKey>;
type CountryCode =
  | "EG"
  | "GH"
  | "NG"
  | "ZM"
  | "KE"
  | "CI"
  | "SN"
  | "TG"
  | "BJ"
  | "BF"
  | "MX"
  | "TZ";
type CountryAssetMap = Record<RequiredCountryAssetKey, string> &
  Partial<Record<OptionalCountryAssetKey, string>>;

const COUNTRY_ASSET_OVERRIDES: Record<
  CountryCode,
  CountryAssetMap
> = {
  EG: {
    logo: EgLogo,
    firstUpBanner50: EgBanner50,
    loginPosterCover: EgLoginCover,
    loginPopup: EgLoginPopup,
    invitePopup: EgInvitePopup,
    installBannerFacebook: EgInstallFacebook,
    installBannerDefault: EgInstallDefault,
    withdrawOfficialAppHero: EgWithdrawOfficialAppHero,
  },
  GH: {
    logo: GhLogo,
    firstUpBanner50: GhBanner50,
    loginPosterCover: GhLoginCover,
    loginPopup: GhLoginPopup,
    invitePopup: GhInvitePopup,
    installBannerFacebook: GhInstallFacebook,
    installBannerDefault: GhInstallDefault,
    withdrawOfficialAppHero: GhWithdrawOfficialAppHero,
  },
  NG: {
    logo: NgLogo,
    firstUpBanner50: NgBanner50,
    loginPosterCover: NgLoginCover,
    bottomInfoLicense1: NgLicense1,
    bottomInfoLicense2: NgLicense2,
    loginPopup: NgLoginPopup,
    invitePopup: NgInvitePopup,
    installBannerFacebook: NgInstallFacebook,
    installBannerDefault: NgInstallDefault,
    withdrawOfficialAppHero: NgWithdrawOfficialAppHero,
  },
  ZM: {
    logo: ZmLogo,
    firstUpBanner50: ZmBanner50,
    loginPosterCover: ZmLoginCover,
    loginPopup: ZmLoginPopup,
    invitePopup: ZmInvitePopup,
    installBannerFacebook: ZmInstallFacebook,
    installBannerDefault: ZmInstallDefault,
    withdrawOfficialAppHero: ZmWithdrawOfficialAppHero,
  },
  KE: {
    logo: KeLogo,
    firstUpBanner50: KeBanner50,
    loginPosterCover: KeLoginCover,
    loginPopup: KeLoginPopup,
    invitePopup: KeInvitePopup,
    installBannerFacebook: KeInstallFacebook,
    installBannerDefault: KeInstallDefault,
    withdrawOfficialAppHero: KeWithdrawOfficialAppHero,
  },
  CI: {
    logo: CiLogo,
    firstUpBanner50: CiBanner50,
    loginPosterCover: CiLoginCover,
    loginPopup: CiLoginPopup,
    invitePopup: CiInvitePopup,
    installBannerFacebook: CiInstallFacebook,
    installBannerDefault: CiInstallDefault,
    withdrawOfficialAppHero: CiWithdrawOfficialAppHero,
  },
  SN: {
    logo: SnLogo,
    firstUpBanner50: SnBanner50,
    loginPosterCover: SnLoginCover,
    loginPopup: SnLoginPopup,
    invitePopup: SnInvitePopup,
    installBannerFacebook: SnInstallFacebook,
    installBannerDefault: SnInstallDefault,
    withdrawOfficialAppHero: SnWithdrawOfficialAppHero,
  },
  TG: {
    logo: TgLogo,
    firstUpBanner50: TgBanner50,
    loginPosterCover: TgLoginCover,
    loginPopup: TgLoginPopup,
    invitePopup: TgInvitePopup,
    installBannerFacebook: TgInstallFacebook,
    installBannerDefault: TgInstallDefault,
    withdrawOfficialAppHero: TgWithdrawOfficialAppHero,
  },
  BJ: {
    logo: BjLogo,
    firstUpBanner50: BjBanner50,
    loginPosterCover: BjLoginCover,
    loginPopup: BjLoginPopup,
    invitePopup: BjInvitePopup,
    installBannerFacebook: BjInstallFacebook,
    installBannerDefault: BjInstallDefault,
    withdrawOfficialAppHero: BjWithdrawOfficialAppHero,
  },
  BF: {
    logo: BfLogo,
    firstUpBanner50: BfBanner50,
    loginPosterCover: BfLoginCover,
    loginPopup: BfLoginPopup,
    invitePopup: BfInvitePopup,
    installBannerFacebook: BfInstallFacebook,
    installBannerDefault: BfInstallDefault,
    withdrawOfficialAppHero: BfWithdrawOfficialAppHero,
  },
  MX: {
    logo: MxLogo,
    firstUpBanner50: MxBanner50,
    loginPosterCover: MxLoginCover,
    loginPopup: MxLoginPopup,
    invitePopup: MxInvitePopup,
    installBannerFacebook: MxInstallFacebook,
    installBannerDefault: MxInstallDefault,
    withdrawOfficialAppHero: MxWithdrawOfficialAppHero,
  },
  TZ: {
    logo: TzLogo,
    firstUpBanner50: TzBanner50,
    loginPosterCover: TzLoginCover,
    loginPopup: TzLoginPopup,
    invitePopup: TzInvitePopup,
    installBannerFacebook: TzInstallFacebook,
    installBannerDefault: TzInstallDefault,
    withdrawOfficialAppHero: TzWithdrawOfficialAppHero,
  },
};

const normalizeCountryCode = () => {
  const code = getCurrentCountryCode();
  if (!code) return "";
  if (code.toLowerCase() === "dev") return "KE";
  return code.toUpperCase();
};

const logMissingCountryAsset = (code: string, key: CountryAssetKey) => {
  if (typeof console !== "undefined") {
    console.error(
      `[countryAssetUtils] Missing asset "${key}" for country "${code || "unknown"}"`,
    );
  }
};

export const getCountryAsset = (
  key: RequiredCountryAssetKey,
): string => {
  const code = normalizeCountryCode();
  const asset = COUNTRY_ASSET_OVERRIDES[code as CountryCode]?.[key];

  if (!asset) {
    logMissingCountryAsset(code, key);
    return "";
  }

  return asset;
};

export const getCountryAssetOptional = (
  key: OptionalCountryAssetKey,
): string | undefined => {
  const code = normalizeCountryCode();
  return COUNTRY_ASSET_OVERRIDES[code as CountryCode]?.[key];
};
